import { Injectable, Signal, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { CategoryType } from '@core/shared/domain';
import { SelectOption } from '@core/ui';
import { CategoriesService, CategoryTypeDescription } from '@mpcm/shared';

import { typeDescriptions } from '../consts';
import { ArticleRangeFilterType } from '../models';

@Injectable()
export class CategoryTypesService {
  readonly categoryTypesDescriptions: Signal<CategoryTypeDescription[]> = toSignal(
    this.categoriesService.fetchCategoryTypes(),
    {
      initialValue: [],
    },
  );

  readonly categoryTypesSelectOptions: Signal<SelectOption<CategoryType>[]> = computed<SelectOption<CategoryType>[]>(
    () => this.mapCategoriesToSelectOptions(),
  );

  constructor(private readonly categoriesService: CategoriesService) {}

  private mapCategoriesToSelectOptions(): SelectOption<CategoryType>[] {
    return this.categoryTypesDescriptions().map(({ type, description }) => ({
      value: type,
      label: description,
      icon: typeDescriptions[ArticleRangeFilterType.Category].icon,
    }));
  }
}
